var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.665 3.813L11.6 1.24l-.86 1.02 3.066 2.573.86-1.02zM5.252 2.26l-.853-1.02-3.067 2.567.86 1.02 3.06-2.567zm3.08 3.073h-1v4l3.167 1.9.5-.82-2.667-1.58v-3.5zm-.333-2.666a6 6 0 100 12 6 6 0 000-12zm0 10.666a4.663 4.663 0 01-4.667-4.666A4.663 4.663 0 017.999 4a4.663 4.663 0 014.666 4.667A4.663 4.663 0 018 13.333z",
    fill: "#9E9E9E"
  })));
}

export default SvgAlarm;